import { SolicitacaoSgsia } from './solicitacao-sgsia';
export class RevisaoSeloSgsia{

    public static readonly SITUACAO_ANALISE_ATIVO     = 'ATIVO';
    public static readonly SITUACAO_ANALISE_SUSPENSO  = 'SUSPENSO';
    public static readonly SITUACAO_ANALISE_CANCELADO = 'CANCELADO';

    public static readonly SITUACAO_REVISAO_EM_REVISAO = 'EM_REVISAO';
    public static readonly SITUACAO_REVISAO_SUSPENSO   = 'SUSPENSO';
    public static readonly SITUACAO_REVISAO_REVISADA   = 'REVISADA';
    public static readonly SITUACAO_REVISAO_FINALIZADA = 'FINALIZADA';

	idRevisao: number;
    idSolicitacao: number;
    solicitacao: SolicitacaoSgsia;
	situacaoRevisao?: string; //TipoSituacaoRevisaoEnum
	prazoParaRevisar: (undefined | 30 | 60 | 90);
	revisaoSolicitada: string;
	dataSolicitacao?: Date;
    situacaoAnalise?: string;
    analise?: string;
	dataAnalise?: Date;
    situacaoAnaliseSuspensao?: string;
    analiseSuspensao?: string;
	dataAnaliseSuspensao?: Date;
	arquivosSolicitacao: Array<any>; //List<ArquivoSolicitacaoRevisaoSelo>
	arquivosAnalise: Array<any>; //List<ArquivoVerificacaoRevisaoSelo>
	arquivosAnaliseSuspensao: Array<any>; //List<ArquivoVerificacaoRevisaoSelo>
    idSolicitante?: number;
    idFiscal?: number;

    static fromJson(jsonData: any): RevisaoSeloSgsia{
        if (jsonData.solicitacao != null) {
            jsonData.solicitacao = SolicitacaoSgsia.fromJson(jsonData.solicitacao);
        }

        return Object.assign(new RevisaoSeloSgsia(), jsonData);
    }

    get descricaoSituacaoRevisao():string{
        if (this.situacaoRevisao === RevisaoSeloSgsia.SITUACAO_REVISAO_EM_REVISAO) {
            return 'Em Revisão';
        }
        if (this.situacaoRevisao === RevisaoSeloSgsia.SITUACAO_REVISAO_FINALIZADA) {
            return 'Finalizada';
        }
        if (this.situacaoRevisao === RevisaoSeloSgsia.SITUACAO_REVISAO_REVISADA) {
            return 'Revisada';
        }
        if (this.situacaoRevisao === RevisaoSeloSgsia.SITUACAO_REVISAO_SUSPENSO) {
            return 'Suspenso';
        }
        return this.situacaoRevisao;
    }


    private descSituacaoAnalise(situacao: string):string{
        if (situacao === RevisaoSeloSgsia.SITUACAO_ANALISE_ATIVO) {
            return 'Ativo';
        }
        if (situacao === RevisaoSeloSgsia.SITUACAO_ANALISE_CANCELADO) {
            return 'Cancelado';
        }
        if (situacao === RevisaoSeloSgsia.SITUACAO_ANALISE_SUSPENSO) {
            return 'Suspenso';
        }
        return situacao;
    }

    get descricaoSituacaoAnalise():string{
        return this.descSituacaoAnalise(this.situacaoAnalise);
    }

    get descricaoSituacaoAnaliseSuspensao():string{
        return this.descSituacaoAnalise(this.situacaoAnaliseSuspensao);
    }


}
